'use client';

import {Spinner} from '@components/Spinner';
import {useSignIn} from '@hooks/useSignIn';
import {useSession} from 'next-auth/react';
import {useRouter, useSearchParams} from 'next/navigation';
import type {FC} from 'react';
import {useLayoutEffect} from 'react';

const Login: FC = () => {
  const {status} = useSession();
  const router = useRouter();
  const searchParams = useSearchParams();
  const {trigger: signIn, isMutating, reset} = useSignIn();

  useLayoutEffect(() => {
    // next-auth is still loading
    if (status === `loading`) return () => {};
    // We triggered the sign in action already
    if (isMutating) return () => reset();
    // The user is authenticated, we don't need to do anything (middleware/ root page.tsx will redirect based on the user role)
    if (status === `authenticated`) return () => {};

    const params = Object.fromEntries(searchParams);
    // Remove 'callbackUrl' query param if it's 'logout' to avoid redirecting to the logout page
    if (params.callbackUrl === `/logout`) {
      delete params.callbackUrl;
    }
    signIn({params});

    return () => reset();
  }, [isMutating, reset, router, status, signIn, searchParams]);

  return <Spinner />;
};

export default Login;
